import appboy from '@braze/web-sdk';
import HttpService from 'services/HttpServiceBasic';
import UserStatus from 'models/UserStatus';
import BrazeConstants from 'models/BrazeConstants';
import {UserPackageSource} from "../models/UserPackage";


const PROFILE_MANAGER_BASE_PATH = '/user-profile/';

export default class Braze {

    sdkEndpoint = CBS.Registry.Braze.env.braze_sdk_endpoint;
    apiKey = CBS.Registry.Braze.env.braze_api_key;
    safariPushId = CBS.Registry.Braze.env.braze_safari_push_id;
    http = null;
    logging = CBS.Registry.Braze.env.braze_logging_enabled;
    initialized = false;
    onInit = [];

    constructor() {
        this.http = new HttpService();
        
        this.isUserProfileQualified()
            ? this.init(CBS.Registry.user.profile_id) 
            : appboy.destroy();
    }

    init(currentProfileId) {
        appboy.initialize(this.apiKey, {
            baseUrl: this.sdkEndpoint,
            enableLogging: this.logging,
            serviceWorkerLocation: '/sw.js',
            safariWebsitePushId: this.safariPushId,
            allowUserSuppliedJavascript: true,
            inAppMessageZIndex: 100050,
            doNotLoadFontAwesome: true
        });

        // Register profile and opens session
        try {
            appboy.getUser().getUserId((profileId) => {
                if (profileId === String(currentProfileId)) {
                    this.openAppboySession();
                } else {
                    this.registerUserProfile();
                    this.requestBrowserNotificationPermission();
                }
            });
        } catch (e) {
            console.log('Unable to init Braze user', e);
        }
        
        // Add Braze session to CBS object
        CBS.Braze = {brazeObj: this, appboy: appboy};
    }

    registerUserProfile() {
        this.getUserProfile()
            .then((response) => {
                if (response && response['activeProfile']) {
                    let activeProfile = response['activeProfile'];

                    appboy.changeUser(activeProfile.id);
                    let user = appboy.getUser();

                    user.setFirstName(activeProfile.id.toString());
                    user.setAvatarImageUrl(activeProfile.profilePicPath);

                    // Set custom user attributes
                    Object.keys(this.getProfileAttributes(activeProfile.profileType)).map((key) => {
                        user.setCustomUserAttribute(key, this.getProfileAttributes(activeProfile.profileType)[key]);
                    });

                    user.setPushNotificationSubscriptionType(
                        appboy.User.NotificationSubscriptionTypes.SUBSCRIBED
                    );

                    this.openAppboySession();
                }
            })
            .catch((err) => {
                console.error(`Get User Profile Error: ${err.message}`);
            });
    }

    openAppboySession() {
        appboy.display.automaticallyShowNewInAppMessages();
        appboy.openSession();
        appboy.registerAppboyPushMessages();

        // Braze session is initialized
        this.initialized = true;
        for (let i = 0; i <= this.onInit.length; i++) {
            if (typeof this.onInit[i] === 'function') {
                this.onInit[i]();
            }
        }
    }
    
    getUserProfile() {
        const url = '/user-profile/xhr/user/';
        return this.http.doGet(url);
    }

    isInitialized() {
        return this.initialized;
    }

    setOnInit(callback = function () {}) {
        this.onInit.push(callback);
    }

    getProfileAttributes(activeProfileType) {
        const plan = CBS.Registry.user.plan;
        const userMVPDAuthz = CBS.Registry.user.isMVPDAuthZ;
        const subStatus = CBS.Registry.user.sub_status;
        const showtimeBundle = CBS.Registry.user.hasShowtimeAddon;
        const brandPlatformId = CBS.Registry.brand_platform_desktop_id;
        const userStateRecurly = CBS.Registry.user.source === UserPackageSource.SOURCE_RECURLY;
        const USER_STATUS = {
            an: UserStatus.STATUS_ANONYMOUS,
            sb: UserStatus.STATUS_SUBSCRIBER,
            rg: UserStatus.STATUS_REGISTERED,
            esb: UserStatus.STATUS_EX_SUBSCRIBER,
        }

        return {
            'profileType': activeProfileType,
            'Plan - CF Annual': plan === BrazeConstants.PLAN_TYPES.cf['0'],
            'Plan - CF Monthly': plan === BrazeConstants.PLAN_TYPES.cf['1'],
            'Plan - LC Annual': plan === BrazeConstants.PLAN_TYPES.lc['0'],
            'Plan - LC Monthly': plan === BrazeConstants.PLAN_TYPES.lc['1'],
            'Plan - LCP Annual': plan === BrazeConstants.PLAN_TYPES.lcp['0'],
            'Plan - LCP Monthly': plan === BrazeConstants.PLAN_TYPES.lcp['1'],
            'User State - MVPD_AUTHZ': userMVPDAuthz,
            'User State - Ex Subscriber': subStatus === USER_STATUS.esb,
            'User State - Registered': subStatus === USER_STATUS.rg,
            'User State - Subscriber': subStatus === USER_STATUS.sb,
            'BrandPlatformID': brandPlatformId,
            'showtime bundle': showtimeBundle,
            'User State - Recurly': userStateRecurly,
        }
    }

    isUserProfileQualified() {
        return CBS.Registry.Features.braze_sdk === true &&
            CBS.Registry.user_auth &&
            CBS.Registry.user.profile_type === 'ADULT';
    }

    /**
     * Request Push Notification Permission
     * if browser supports notifications
     */
    requestBrowserNotificationPermission() {
        // 
        let path = window.location.pathname;
        if (
            appboy.isPushSupported() &&
            !appboy.isPushPermissionGranted() &&
            !path.includes(PROFILE_MANAGER_BASE_PATH)
        ) {
            if (typeof Notification !== "undefined") Notification.requestPermission()
        }

    }
    
    testIAM(){
        return this.logging && this.initialized
            ? appboy.logCustomEvent('page_view',{'name':'testIAM'})
            : false;
    }
}
